module.exports = __webpack_public_path__ + "img/registerltedevice.e1ca5679.png";